export default "__VITE_ASSET__48bf5ec1__"